export const errorValidationMessages = {
  REQUIRED: 'Обязательно для заполнения',
  MIN: 'Минимум %% символов',
  MAX: 'Минимум %% символов'
};
